import gql from 'graphql-tag'

export const GET_RAW_ALERTS_VIDEO_HISTORY = gql`
  query RawAlerts($filter: GetRawAlertFilter) {
    rawAlerts(filter: $filter) {
      rawAlerts {
        data {
          alert {
            alertCode
            descriptionEng
            descriptionIdn
            iconUrl
          }
          alertCode
          createdOn
          isUrgent
          isImportant
        }
      }
      message
      isSuccessful
    }
  }
`
